<template>
    <div class="container">
        <div class="other_box" v-html="column_content.content"></div>
    </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex'

export default {
    computed: mapState({
        column_content: state => state.other.column_content
    }),
    methods: {
        ...mapMutations([
            "clearColumnContent"
        ]),
        ...mapActions([
            "getColumnContent"
        ])
    },
    beforeRouteEnter (to, from, next) {
        // ...
        next(vm => {
            let id = null;
            if(!to.query.id){
                switch(to.name){
                    case "about" :
                        id = 1;
                        break;
                    case "culture" :
                        id = 7;
                        break;
                    case "news" :
                        id = 8;
                        break;
                    case "contact" :
                        id = 9;
                        break;
                }
            }else{
                id = to.query.id
            }
            vm.getColumnContent(id)
        })
    },
    beforeRouteUpdate (to, from, next) {
        this.getColumnContent(to.query.id);
        next();
    },
    beforeRouteLeave (to, from, next) {
        // ...
        this.clearColumnContent();
        next();
    }
}
</script>

<style scoped>
.other_box{
    padding: 50px 0;
}
</style>
